<template>
  <div>
    <FilterToolbar
      :hasChanges="hasChanges"
      :appliedFilters="appliedFilters"
      :allowSearch="true"
      :allowFilters="true"
      :searchParams="searchParams"
      defaultSearchParam="identifier"
      @search="search"
      @update="update"
      @clear="clear">
      <FacetFilter
        v-model="filters.facets.status"
        :filter="filterOptions.status"
        @input="change"
      />
    </FilterToolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as filterOptions from '../../filters/active.js'
import FilterToolbar from '@/components/Filters/FilterToolbar'
import FacetFilter from '@/components/Filters/FacetFilter'

export default {
  components: {
    FacetFilter,
    FilterToolbar
  },
  computed: {
    ...mapGetters(['context']),
    searchParams () {
      return [{
        label: 'Project Name',
        code: 'name'
      }, {
        label: 'SoW or PO #',
        code: 'identifier'
      }, {
        label: 'Client',
        code: 'client_name'
      }, {
        label: 'Organization',
        code: 'organization_name'
      }, {
        label: 'GatherWorks ID',
        code: 'id'
      }]
    }
  },
  data () {
    return {
      hasChanges: false,
      filters: null,
      // filters
      filterOptions: filterOptions
    }
  },
  methods: {
    change () {
      this.hasChanges = true
    },
    search (searchQuery) {
      this.filters.search = {
        parameter: searchQuery.param,
        query: searchQuery.query
      }
      this.$emit('filter', this.filters)
    },
    update () {
      this.hasChanges = false
      this.filters.preset = 'custom'
      this.$emit('filter', this.filters)
    },
    clear () {
      this.filters = {
        preset: 'all',
        facets: {},
        search: {},
        timestamps: {}
      }
      this.$emit('filter', this.filters)
    }
  },
  mounted () {

  },
  props: {
    appliedFilters: {
      type: Object,
      required: true
    }
  },
  watch: {
    appliedFilters: {
      deep: true,
      immediate: true,
      handler (filters) {
        this.filters = filters
      }
    }
  }
}
</script>
